module.exports = __webpack_public_path__ + "static/media/04_kittel.add0d136.jpg";